
export enum CurrentContext {
	LANDING,
	DOMESTIC,
	INTERNATIONAL,
	REGION,
	DIOCESE,
	INTERNATIONDIO,
}

export enum MapContext {
	LANDING,
	DOMESTIC,
	INTERNATIONAL,
}

export enum ReportContext {
	PROVINCE,
	DIO,
}


export interface ClergyCompReportState {
	currentContext: CurrentContext,
	selectedRegion: string,
	selectedDio: string,
	dioHovered: string,
	mapContext: MapContext,
	reportContext: ReportContext,
	filter: any,
	ports: any,
}

export enum ClergyCompReportActions {
	SET_CLERGY_REPORT_CONTEXT = 'SET_CLERGY_REPORT_CONTEXT',
	SET_SELECTED_REGION = 'SET_SELECTED_REGION',
	SET_SELECTED_DIO = 'SET_SELECTED_DIO',
	SET_MAP_CONTEXT = 'SET_MAP_CONTEXT',
	SET_DIO_HOVER = 'SET_DIO_HOVER',
	SET_PORT = 'SET_PORT',
	SET_REPORT_CONTEXT = 'SET_REPORT_CONTEXT',
	SET_MAP_FILTER = 'SET_MAP_FILTER',
}

export const regionMap = {
	p8: [
		'Alaska',
		'Hawaii',
		'California',
		'San Joaquin',
		'El Camino Real',
		'Los Angeles',
		'San Diego',
		'Nevada',
		'Northern California',
		'Eastern Oregon',
		'Oregon',
		'Olympia',
		'Spokane',
		'Idaho',
		'Utah',
		'Arizona',
		'Navajoland Area Mission',
	],
	p7: [
		'The Rio Grande',
		'Northwest Texas',
		'Fort Worth',
		'Texas',
		'Dallas',
		'Oklahoma',
		'Western Kansas',
		'Kansas',
		'West Missouri',
		'Arkansas',
		'Western Louisiana',
		'West Texas',
	],
	p6: [
		'Colorado',
		'Wyoming',
		'Montana',
		'Nebraska',
		'South Dakota',
		'North Dakota',
		'Iowa',
		'Minnesota',
	],
	p5: [
		'Northern Indiana',
		'Indianapolis',
		'Springfield',
		'Missouri',
		'Chicago',
		'Southern Ohio',
		'Ohio',
		'Michigan',
		'Eastern Michigan',
		'Western Michigan',
		'Milwaukee',
		'Fond du Lac',
		'Eau Claire',
		'Northern Michigan',
	],
	p4: [
		'Southeast Florida',
		'Southwest Florida',
		'Central Florida',
		'Florida',
		'South Carolina',
		'Upper South Carolina',
		'Central Gulf Coast',
		'Louisiana',
		'Georgia',
		'Atlanta',
		'Alabama',
		'Mississippi',
		'Kentucky',
		'Lexington',
		'West Tennessee',
		'Tennessee',
		'East Tennessee',
		'Western North Carolina',
		'North Carolina',
		'East Carolina',
	],
	p3: [
		'Southern Virginia',
		'Southwestern Virginia',
		'West Virginia',
		'Virginia',
		'Washington',
		'Maryland',
		'Easton',
		'Delaware',
		'Pittsburgh',
		'Northwestern Pennsylvania',
		'Central Pennsylvania',
		'Pennsylvania',
		'Bethlehem',
	],
	p2: [
		'New Jersey',
		'Newark',
		'New York',
		'Long Island',
		'Western New York',
		'Rochester',
		'Central New York',
		'Albany',
	],
	p1: [
		'Connecticut',
		'Rhode Island',
		'Western Massachusetts',
		'Massachusetts',
		'Vermont',
		'New Hampshire',
		'Maine',
	],
};